import React  from 'react';
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle,Typography
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useState } from 'react';

const PopUpMsg = (props) => {

    const [value, setValue] = useState('');
    
    const handelChange = (event) => {
        
        setValue(event.target.value)
        props.handleComment(event.target.value)
    }

   
   
    return (
        <div>
            <Dialog
                open={true}
                aria-labelledby="customized-dialog-title"     
                width = {'min-content'}

            >
               {props.popUpMessage.heading ? <DialogTitle id="customized-dialog-title" >
                    {props.popUpMessage.heading} 
                </DialogTitle> : '' }

                <DialogContent dividers>
                    <Typography gutterBottom id="mergePopupMsg">
                        {props.popUpMessage.message}
                    </Typography>

                   { props.popUpMessage.comment &&
                   <TextField
                        required
                        value={value}
                        className='w-100'
                        onChange={handelChange}
                        multiline
                        rows={2}
                        variant="outlined"
                        error={props.commentFlag && value.length === 0}
                        helperText={props.commentFlag && value.length === 0 ? "Please Enter Value" : " "}
                        placeholder="Enter Comment"
                        
                    />
                   }
                
                </DialogContent>
                <DialogActions sx={{mr: '15px'}}>

                {props.popUpMessage.cancel &&
                         <Button onClick={props.onCancel} autoFocus color="error" variant="outlined" className='_wg-dynamic-text' >
                         {props.popUpMessage.cancel}
                     </Button>
                    }
                    {props.popUpMessage.onOk && 
                    <Button onClick={props.onOK} autoFocus  color="error" variant="contained" className='_wg-dynamic-text' >
                    {props.popUpMessage.onOk}
                    </Button>
                    }  

                    {
                        props.popUpMessage.onClose &&
                        <Button onClick={props.onClose} autoFocus  color="error" variant="outlined" className='_wg-dynamic-text'>
                    {props.popUpMessage.onClose}
                    </Button>
                    }    
                    
                </DialogActions>
            </Dialog>
        </div>


    )
}

export default PopUpMsg;